export default [
  /** 挽留用户弹泡 */
  {
    path: '/activity/retainuserpay',
    name: 'RetainUserPay',
    component: () => import('@/views/Activity/RetainUserPay')
  }
]
